const prefix = 'CREATE_PROMO_CODE_ACTIONS_';
export const SAVE_PROMO_CODE = `${prefix}SAVE_PROMO_CODE`;
